const styles = `:host {
  width: 1px;
  border-right: 1px solid;
  border-color: var(--goto-field-01);
  margin-right: 4px;
}`; export default styles;